<template>
  <LayoutPopup id="check-barcode" size="medium">
    <template #title>Dán đè mã vạch</template>
    <template #content>
      <div class="text-center">
        <span>
          <img src="@/assets/images/barcode-overwrite.svg">
        </span>
        <div>
          <p v-if="checkItem" class="mb-0">Có {{ existedUpc.length }} phiên bản sản phẩm đã tồn tại mã vạch</p>
          <p v-else class="mb-0">
            Tất cả phiên bản của sản phẩm được chọn đã được tạo mã vạch.
          </p>
        </div>
        <p class="">Bạn có muốn tạo mới mã cho tất cả phiên bản dưới đây?</p>
      </div>

      <div class="text-center list-default-wrapper">
        <ul class="list-default">
          <li 
            v-for="(item, index) in existedUpc" 
            :key="index"
          >
            {{item.name}}
          </li>
          
        </ul>
      </div>
    </template>
    <template #control-right>
      <!-- <BaseButton 
        size="sm"
        variant="primary"
        v-if="checkItem"
        @click="generateBarcode('cancel')"
      >
        Bỏ qua sản phẩm có mã
      </BaseButton>
      
      <BaseButton 
        size="sm"
        variant="primary"
        v-else
        @click="hidePopup('check-barcode')"
      >
        Bỏ qua
      </BaseButton> -->
      <el-button v-if="checkItem" type="text" @click="generateBarcode('cancel')" :loading="btnLoadingCancel">Bỏ qua sản phẩm có mã</el-button>
      <el-button v-else @click="hidePopup('check-barcode')" type="primary" plain>Bỏ qua</el-button>
      <el-button type="primary" @click="generateBarcode('overwrite')" :loading="btnLoading">Tạo mới ngay</el-button>
      <!-- <BaseButton 
        size="sm"
        @click="generateBarcode('overwrite')"
      >
        Tạo mới ngay
      </BaseButton> -->
    </template>
  </LayoutPopup>
</template>

<script>
import genBarcode from "@/mixins/items/handleBarcode"
import updateItemBarcode from "@/mixins/items/handleBarcode"

export default {
  mixins: [
    genBarcode,
    updateItemBarcode,
  ],
  props: {
    existedUpc: {
      type: Array,
      default: []
    },
    selectedBox: {
      type: Array,
      default: []
    },
    type: {
      type: String,
      default: "items"
    } 
  },
  data() {
    return {
      checkItem: false,
      btnLoading: false,
      btnLoadingCancel: false
    }
  },
  watch: {
    selectedBox: {
      handler: function () {
        let resultItem = []

        if (this.type === "items") {
          resultItem = this.selectedBox.map(e => {
            const resultVariation = e.variations.filter(variation => variation.upc != '')
            return resultVariation.length == e.variations.length
          })
        } else {
          const resultVariation = this.selectedBox.filter(variation => variation.upc != '')
          resultItem = resultVariation.length == this.selectedBox.length ? [true] : [false]
        }
        this.checkItem = resultItem.includes(false)
      }
    }
  },
  created() {
    
  },
  methods: {
    async generateBarcode(typeAction) {
      try {
        const quantity = (typeAction === "cancel")
          ? (this.selectedBox.length - this.existedUpc.length)
          : this.selectedBox.length

        let result = [] 
        if (this.type === "variations") {
          let resBarcode = await this.genBarcode(quantity)
          resBarcode = resBarcode.split(",");
          console.log(resBarcode);

          for (let index = 0; index < this.selectedBox.length; index++) {
            const element = this.selectedBox[index];
            if (element.upc == "" && typeAction === "cancel") {
              await result.push({
                ...element,
                upc: resBarcode[0]
              })
              resBarcode.splice(0, 1)
            } else if (typeAction === "overwrite") {
              result.push({
                ...element,
                upc: resBarcode[index]
              })
            } else {
              result.push(element)
            }
          }
        } else {
          const ids = this.selectedBox && this.selectedBox.map(e => e.id)
          console.log(ids);
          // call api upc for item
          if (typeAction === "overwrite") {
            this.btnLoading = true
            result = await this.updateItemBarcode(ids, true)
            if (result) {
              this.btnLoading = false
            }
          } else {
            this.btnLoadingCancel = true
            result = await this.updateItemBarcode(ids, false)
            if (result) {
              this.btnLoadingCancel = false
            }
          }
        }

        this.$emit("getValue", result)
        this.hidePopup('check-barcode')
      } catch (error) {
        console.log(error);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.__popup {
  .__content {
    overflow: hidden;
  }
}

.list-default-wrapper {
  position: relative;
  overflow-y: auto;
  height: 100px;

  &::-webkit-scrollbar {
    display: none;
  }

  &:after {
    position: absolute;
    height: 50px;
    width: 100%;
    content: "";
    bottom: 0;
    left: 0;
    z-index: 99;
    background: linear-gradient(to top, white, rgba(255, 255, 255, 0.2));
  }
}

.list-default {
  position: relative;
  height: 80px;
  margin-bottom: 0;
  overflow-y: auto;
  z-index: 99;
  color: #9093A4;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>